import { render, staticRenderFns } from "./results.vue?vue&type=template&id=54c92037&scoped=true"
import script from "./results.vue?vue&type=script&lang=js"
export * from "./results.vue?vue&type=script&lang=js"
import style0 from "./results.vue?vue&type=style&index=0&id=54c92037&prod&lang=scss&scoped=true"
import style1 from "./results.vue?vue&type=style&index=1&id=54c92037&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c92037",
  null
  
)

export default component.exports